/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Prompt_TitleInputs */



/**
* | output |
* | --- |
* | "Send email notification?" |
*
* @param {Explorer_Assignment_Email_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_prompt_title = /** @type {((inputs?: Explorer_Assignment_Email_Prompt_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Prompt_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer une notification par e-mail ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail-Benachrichtigung senden?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inviare una notifica via email?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправить уведомление по электронной почте?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Enviar notificación por correo?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发送电子邮件通知？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールで通知しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल सूचना भेजें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviar notificação por e-mail?")
	return /** @type {LocalizedString} */ ("Send email notification?")
});